import React from 'react'
import PropTypes from 'prop-types'
import { Button, Typography } from '@chilecompra/react-kit/components'
import { REACT_APP_MP_URL, REACT_APP_DA_ABOUT_URL } from '../../config/settings/environment'
import { Dialog, GridContainer, GridItem, Link, Strong } from './RegionalDataDialog.styles'

/**
 * The RegionalDataDialog's component.
 */
const RegionalDataDialog = props => {
  const { open, onClose } = props

  return (
    <Dialog open={open} onClose={onClose}>
      <GridContainer>
        <GridItem xs={12}>
          <Typography align="left" color="black1" fontSize="16px" variant="body1" fontWeight="bold">
            ¿Cómo se obtiene la información de esta región?
          </Typography>
          <Typography align="left" color="black1" fontSize="14px" margin="16px 0" padding="0 24px 0 0" variant="body2">
            Toda la información regional se obtiene desde{' '}
            <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
              www.mercadopublico.cl
            </Link>{' '}
            en base a las órdenes de compra que hayan generado todas las <Strong>unidades de compra</Strong>{' '}
            pertenecientes a la región en la plataforma. Una orden de compra es un documento electrónico emitido por un
            organismo comprador a un proveedor, en donde se solicita la entrega de un producto o servicio y se detalla
            su precio, cantidad y otras condiciones de entrega. Las órdenes de compra en{' '}
            <Link href={REACT_APP_MP_URL} rel="noreferrer" target="_blank">
              www.mercadopublico.cl
            </Link>
            , a partir de las cuales se calculan los montos, corresponden a compromisos y no a pagos de los organismos
            del Estado.
            <br />
            <br />
            La información se actualiza mensualmente con información oficial del Datawarehouse institucional, la que
            tiene un mes debido a su procesamiento y depuración. Para más información puedes visitar el siguiente{' '}
            <Link href={REACT_APP_DA_ABOUT_URL} rel="noreferrer" target="_blank">
              enlace
            </Link>
          </Typography>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Typography align="left" color="black1" fontSize="16px" variant="body1" fontWeight="bold">
            ¿En que se basan las cifras de montos de esta región?
          </Typography>
          <Typography align="left" color="black1" fontSize="14px" margin="16px 0" padding="0 24px 0 0" variant="body2">
            Los montos indicados en la orden de compra corresponden a compromisos de los organismos, no a pagos. Los
            montos que se presentan en cada uno de los gráficos se obtienen en base a las órdenes de compra que se
            encuentren en los siguientes estados: enviada al proveedor, en proceso, aceptada, solicitud de cancelación y
            recepción conforme. El monto en pesos considera la conversión de las órdenes de compra en otras monedas,
            según el tipo de cambio vigente al momento de la actualización de la información.
          </Typography>
        </GridItem>
      </GridContainer>
      <GridContainer margin="32px 0 0">
        <GridItem align="center" xs={12}>
          <Button color="default" type="button" onClick={onClose}>
            Cerrar
          </Button>
        </GridItem>
      </GridContainer>
    </Dialog>
  )
}

RegionalDataDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default RegionalDataDialog
